import { DefaultModel } from './../../../../core/framework/default.model';
import { TipoProduto } from './../../../../core/enums/produto.enum';
import { IItemProdutoRetirada } from '../../item-produto-retirada/item-produto-retirada.model';
import { StatusRetirada } from './../../../../core/enums/status-retirada.enum';
import { Unidade } from 'src/app/farmacia/unidade/unidade.model';

export interface ILoteRetiradaLista {
  produto: {
    tipo: TipoProduto;
    descricao: string;
    tuss: string;
  };
  quantidade: number;
}

export class Retirada extends DefaultModel {

  unidade: Unidade;

  idUsuarioSolicitacao: number;

  idUsuarioAlteracao: number;

  produtos: IItemProdutoRetirada[] = [];

  dataAlteracao: Date;

  dataSolicitacao: Date;

  dataRetirada: Date;

  statusRetirada: StatusRetirada;

  observacao: string;

}

